/* eslint-disable no-undef */
import { useEffect, useState } from "react";

const useOutsideClick = (ref: any, callback: any) => {
  const handleClick = (e: any) => {
    if (
      e &&
      typeof e?.target?.className === "string" &&
      e?.target?.className?.includes("form-control-language__option")
    ) {
      e.preventDefault();
    } else {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};

export default useOutsideClick;

// This function used for showing scrollbar only when scrolling
export const scrollBar = (callback: (action: boolean) => void) => {
  useEffect(() => {
    let timeoutId: any;

    function handleUserActivity() {
      // Show the scrollbar
      callback(true);

      // Reset the timeout
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        // Hide the scrollbar
        callback(false);
      }, 1000);
    }
    window.addEventListener("wheel", handleUserActivity);
    window.addEventListener("touchmove", handleUserActivity);

    // If needs to show scroll on another mouse event
    // window.addEventListener("mousemove", handleUserActivity);
    // window.addEventListener("mousedown", handleUserActivity);
    // window.addEventListener("touchstart", handleUserActivity);

    // Remove event listeners when the component unmounts
    return () => {
      window.removeEventListener("wheel", handleUserActivity);
      window.removeEventListener("touchmove", handleUserActivity);

      // If needs to show scroll on another mouse event
      // window.removeEventListener("mousemove", handleUserActivity);
      // window.removeEventListener("mousedown", handleUserActivity);
      // window.removeEventListener("touchstart", handleUserActivity);
    };
  }, []);
};
